import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import buttonImage from '../buttonimage.webp';

const FIELD_CONFIG = [
  { key: 'energy_type', label: 'Energy Type' },
  { key: 'strategy', label: 'Strategy' },
  { key: 'inner_authority', label: 'Inner Authority' },
  { key: 'profile', label: 'Profile' },
  { key: 'definition', label: 'Definition' },
  { key: 'incarnation_cross', label: 'Incarnation Cross' },
];

function HumanDesignFields({ worksheetData }) {
  const [fields, setFields] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const initial = {};
    // Avoid complex expressions in the dependency array by
    // referencing `worksheetData` directly here.
    if (!worksheetData) {
      FIELD_CONFIG.forEach(({ key }) => {
        initial[key] = '';
      });
      setFields(initial);
      return;
    }

    FIELD_CONFIG.forEach(({ key }) => {
      initial[key] = worksheetData[key] || '';
    });
    setFields(initial);
  }, [worksheetData]);

  const handleChange = (key, value) => {
    if (value.length <= 35) {
      setFields((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      if (userError || !user) {
        setMessage('User not logged in!');
        setSaving(false);
        return;
      }
      const updateObj = { ...fields };
      const { error } = await supabase
        .schema('api')
        .from('worksheets')
        .upsert({ id: user.id, ...updateObj }, { onConflict: ['id'] });
      if (error) {
        setMessage('Failed to save: ' + error.message);
      } else {
        setMessage('Saved!');
      }
    } catch (err) {
      setMessage('Unexpected error: ' + err.message);
    }
    setSaving(false);
  };

  return (
    <div style={{ width: '100%', marginBottom: 4, paddingLeft: 0 }}>
      <style>{`
        @media (max-width: 600px) {
          .hd-field-row { flex-direction: column !important; align-items: flex-start !important; }
          .hd-field-input { width: 100% !important; min-width: 0 !important; max-width: 100% !important; }
        }
      `}</style>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        alignItems: 'flex-start',
        width: '100%',
        marginBottom: 0,
        paddingLeft: 0,
      }}>
        {FIELD_CONFIG.map(({ key, label }) => (
          <div key={key} className="hd-field-row" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 2, marginRight: 8, whiteSpace: 'nowrap', width: '100%' }}>
            <label style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'normal', marginRight: 0, fontSize: 15, minWidth: 0 }}>{label}:</label>
            <input
              className="hd-field-input"
              type="text"
              value={fields[key] || ''}
              maxLength={35}
              onChange={e => handleChange(key, e.target.value)}
              style={{
                width: '30ch',
                maxWidth: '30ch',
                minWidth: '30ch',
                border: '1px solid #ccc',
                borderRadius: 4,
                padding: '1px 2px',
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: 15,
                fontWeight: 'bold',
                marginLeft: 0,
                marginTop: 0,
              }}
            />
          </div>
        ))}
      </div>
      <div style={{ textAlign: 'center', marginTop: 8 }}>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            backgroundImage: `url(${buttonImage})`,
            backgroundSize: 'cover',
            border: 'none',
            borderRadius: '6px',
            padding: '0 12px',
            width: 'auto',
            minWidth: 40,
            fontFamily: 'Times New Roman, Times, serif',
            fontSize: '13px',
            fontWeight: 'bold',
            boxShadow: '2px 2px 8px rgba(0,0,0,0.25)',
            cursor: saving ? 'not-allowed' : 'pointer',
            margin: '0 auto',
            display: 'inline-block',
            lineHeight: 1.1,
            height: 'auto',
            minHeight: 0,
          }}
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
        {message && <div style={{ fontSize: 12, color: message === 'Saved!' ? 'green' : 'red', marginTop: 2 }}>{message}</div>}
      </div>
    </div>
  );
}

export default HumanDesignFields;
